import Util from '@/util';
/* eslint-disable import/no-cycle */
import Api from '@/api';
/* eslint-enable import/no-cycle */

const theState = {
    loading: false,
    isCheckingCustomer: false,
    ssoId: '',
    email: '',
    first_name: '',
    last_name: '',
    gender: '',
    inCeleraone: false,
    inSalesforce: false,
    inEvalanche: false,
};

const getters = {
    fullname(state) {
        return Util.masterdataToFullName(state);
    },
};

const actions = {
    checkCustomer({ commit }, ssoId) {
        commit('setSsoId', ssoId);
        commit('setLoading', true);
        commit('setIsCheckingCustomer', true);
        commit('setInCeleraone', false);
        commit('setInSalesforce', false);
        commit('setInEvalanche', false);
        return new Promise((resolve, reject) => {
            Api.customer.checkCustomer(ssoId)
                .then(({ data }) => {
                    commit('setLoading', false);
                    commit('setIsCheckingCustomer', false);
                    commit('setMasterdata', data.data);
                    commit('setInCeleraone', data.existInCeleraone);
                    commit('setInSalesforce', data.existInSalesforce);
                    commit('setInEvalanche', data.existInEvalanche);
                    resolve();
                })
                .catch(() => {
                    commit('setIsCheckingCustomer', false);
                    commit('setLoading', false);
                    reject();
                });
        });
    },

    deleteCustomer({ commit, state }) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Api.customer.deleteByMail({
                email: state.email,
                inCeleraone: state.inCeleraone,
                inEvalanche: state.inEvalanche,
                inSalesforce: state.inSalesforce,
            })
                .then(() => {
                    commit('setLoading', false);
                    resolve();
                })
                .catch(() => {
                    commit('setLoading', false);
                    reject();
                });
        });
    },
};

const mutations = {
    resetState(state) {
        state.loading = false;
        state.ssoId = '';
        state.email = '';
        state.first_name = '';
        state.last_name = '';
        state.gender = '';
        state.isCheckingCustomer = false;
    },

    setLoading(state, loading) {
        state.loading = loading;
    },

    setIsCheckingCustomer(state, isCheckingCustomer) {
        state.isCheckingCustomer = isCheckingCustomer;
    },

    setSsoId(state, ssoId) {
        state.ssoId = ssoId;
    },

    setMasterdata(state, {
        login,
        last_name,
        first_name,
        gender,
        store,
    }) {
        state.email = login;
        /* eslint-disable-next-line camelcase */
        state.last_name = last_name;
        /* eslint-disable-next-line camelcase */
        state.first_name = first_name;
        state.gender = gender;
        state.store = store;
    },
    setInCeleraone(state, existInCeleraone) {
        state.inCeleraone = existInCeleraone;
    },

    setInSalesforce(state, existInSalesforce) {
        state.inSalesforce = existInSalesforce;
    },

    setInEvalanche(state, existInEvalanche) {
        state.inEvalanche = existInEvalanche;
    },

};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
